import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";

@Component({
  selector: 'app-branch-list',
  templateUrl: './branch-list.component.html',
  styleUrl: './branch-list.component.css'
})
export class BranchListComponent {
  organizationId: any

  searchKeyword = "";
  displayedColumns: string[] = ['srNo', 'officename', 'primary_contact_name','primary_contact_email','primary_contact_phone','Users', 'state', 'action'];//
  userData: any = [];
  roleName: any
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService,
  ) {



  }
  ngOnInit() {
     const user = localStorage.getItem('user') as any;
    const userParse = JSON.parse(user);
    this.roleName=userParse.user.role_name;
    this.route.params.subscribe((params) => {
      this.organizationId = params['id'];
    });
    this.fetchOrganizationsBranch()
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }


  fetchOrganizationsBranch() {
    this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
      next: (res: any) => {
        console.log('API Response:', res);
        this.dataSource.data = res.data;
      },
      error: (err) => {
        console.log('API Error:', err);
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  deleteOrganization(orgId: number) {
    const confirmDelete = confirm("Are you sure you want to delete this Branch?");
    if (!confirmDelete) {
      return;
    }
    this.apiService.deleteOrganizationBBranch(orgId).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success('Branch deleted successfully');
        this.fetchOrganizationsBranch();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }
  editBranch(element: any): void {
    console.log(element)
     localStorage.setItem("editBranch", JSON.stringify(element));
   this.router.navigate(['/home/organization-edit-branch', element.branch_id]);
  }
}